export default __webpack_public_path__ + "static/media/point.79d2fac4.svg";